import { render, staticRenderFns } from "./drawIns.vue?vue&type=template&id=8e2848f0&scoped=true&"
import script from "./drawIns.vue?vue&type=script&lang=ts&"
export * from "./drawIns.vue?vue&type=script&lang=ts&"
import style0 from "./drawIns.vue?vue&type=style&index=0&id=8e2848f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2848f0",
  null
  
)

export default component.exports